import React from 'react';
import PropTypes from 'prop-types';
import RenderApps from './RenderApps';
import Icon from '../../common/Icon';

function featuredApps(props) {
    const apps = props.apps
        .filter((app) => app.featuredOrder !== -1)
        .sort((a, b) => (a.featuredOrder > b.featuredOrder ? 1 : -1));

    return (
        apps.length > 0 && (
            <div name="featured-apps">
                <h4 className="appsListItems-title">
                    <Icon alias="star-o" /> Featured
                </h4>
                <div className="appsListItemsWrapper">
                    <RenderApps apps={apps} />
                </div>
            </div>
        )
    );
}
featuredApps.propTypes = {
    apps: PropTypes.array,
};
export default featuredApps;
